// i18n area 'vms' — locale pt-BR (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da vms.pt-PT.ts e sovrascrive SOLO le chiavi
// che il brasiliano scrive davvero in un altro modo: lessico (usuário,
// arquivo, tela, senha, registro, seção, configurações, salvar, console) e
// morfologia verbale (il progressivo 'está a fazer' → 'está fazendo').
// DA RIVEDERE DA MADRELINGUA: restano fuori le scelte a bassa confidenza
// (alojar/hospedar, eliminar/excluir, arranque/inicialização) e la posizione
// dei clitici, che una regola meccanica non sa spostare.
// Sidecar anti-stantie: ../meta/vms.pt-BR.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './vms'

export const ptBR: DeepPartial<typeof enUS> = {
  vms: {
    templatesTab: {
      exportHint: 'O template é empacotado num arquivo .tvtpl (manifest de hardware + cada disco achatado em qcow2) como novo arquivo Template VM no catálogo escolhido. NICs, suportes CD/DVD e cloud-init não viajam — a spec do formato lista cada omissão deliberada.',
      exportName: 'Nome do arquivo',
      importHint: 'Um arquivo Template VM ready do catálogo escolhido torna-se um template do inventário: o formato do arquivo (tvtpl, ova, ovf ou qcow2 nu) decide sozinho como se importa — escolhe-se apenas o arquivo.',
      importFile: 'Arquivo de catálogo',
      importFileHint: 'Só se importam arquivos ready — um a meio do upload não é importável',
      importNoFiles: 'Nenhum arquivo Template VM ready neste catálogo — carregue ou exporte um primeiro'
    },
    unusedDisksTab: {
      convertWarning: 'DESTRUTIVO: o disco torna-se um arquivo template VM no catálogo escolhido — mesmo storage, zero bytes copiados — e DEIXA DE EXISTIR como disco. Não há retorno a não ser criando um novo disco a partir do template.',
      convertNameHint: 'O nome do arquivo de catálogo — por padrão o do disco'
    },
    detail: {
      appliedHint: 'A VM está em execução com este valor — o configurado aplica-se no próximo power cycle.',
      tabConsole: 'Console',
      consoleUnavailable: 'O console está disponível com a VM em execução ou em pausa.',
      consoleError: 'A conexão com o console falhou',
      consoleTaken: 'Sessão de console tomada por {user}',
      consoleFullscreen: 'Abrir em tela cheia numa nova aba',
      consoleProtocol: 'Console'
    },
    actions: {
      openConsole: 'Abrir console'
    },
    console: {
      bootOrderHint: 'A nova ordem é salva logo e aplica-se no próximo power cycle — a sessão de console fica ligada.'
    },
    snapshots: {
      memoryHint: 'Captura a RAM viva: a restauração retoma a VM em execução. Exige todos os discos qcow2.',
      deleteBody: 'O ponto de restauração desaparece; o conteúdo dos discos fica intacto.'
    },
    bulk: {
      done: 'aceitas'
    },
    edit: {
      save: 'Salvar'
    }
  }
}
